import { type InjectionKey } from 'vue';

import AnalyticsService from '@/services/analytics/analytics-service.ts';
import type IApiClient from '@/types/api/api-client-interface.ts';

export const DI_API_CLIENT = Symbol() as InjectionKey<IApiClient>;
export const DI_ANALYTICS_SERVICE = Symbol() as InjectionKey<AnalyticsService>;
